class ViewStack {
  constructor() {
    this._views = [];
  }

  push(item) {
    // add previous
    item.prev = this.peek() || null;
    this._views.push(item);
    return item;
  }

  pop() {
    if (this.isEmpty()) {
      return false;
    }
    return this._views.pop();
  }

  peek() {
    return this._views[this._views.length - 1];
  }

  isEmpty() {
    return this._views.length === 0;
  }
}

class MobileMenu {
  constructor({ selector, block, toggleActiveClass }) {
    this._block = block || selector.replace("#", "").replace(".", "");

    this._menuSelector = selector;

    this._isOpen = false;

    this._handleOutsideClick = this._handleOutsideClick.bind(this);
    this._handleEscDown = this._handleEscDown.bind(this);

    this._classes = {
      toggleActiveClass,
      openMenuClass: `${this._block}--open`,
      openViewClass: `${this._block}__view--open`,
      showBackBtnClass: `${this._block}__back-btn--show`,
      customViewClass: "js-mm-custom-view",
      hideFooterClass: `${this._block}__footer--hide`,
    };

    this._selectors = {
      menuElSelector: selector,
      toggleMenuBtnSelector: `.js-mm-toggle`,
      viewActivatorSelector: "[data-menu-id]",
      firstViewSelector: `.${this._block}__view`,
      backBtnSelector: `.js-mms-back-button`,
      backTextSelector: `.${this._block}__back-text`,
      footerSelector: `.${this._block}__footer`,
    };

    this._init();
  }

  _init() {
    const {
      viewActivatorSelector,
      menuElSelector,
      firstViewSelector,
      backBtnSelector,
      backTextSelector,
      toggleMenuBtnSelector,
      footerSelector,
    } = this._selectors;

    // get menu element
    this._menuEl = document.querySelector(menuElSelector);

    if (!this._menuEl) {
      return console.error(
        `Unable to find mobile menu element with "${menuElSelector}"`
      );
    }

    // get togglers
    this._menuTogglers = [...document.querySelectorAll(toggleMenuBtnSelector)];

    // get first view
    this._mainView = this._menuEl.querySelector(firstViewSelector);

    this._viewStack = new ViewStack();

    // get back button
    this._backBtns = this._menuEl.querySelectorAll(backBtnSelector);

    // get footer
    this._footer = this._menuEl.querySelector(footerSelector);

    // get back button text span
    this._backText = this._menuEl.querySelector(backTextSelector);

    // collect all sub menu buttons
    this._viewActivators = [
      ...this._menuEl.querySelectorAll(viewActivatorSelector),
    ];

    this._setEventListeners();
  }

  _setEventListeners() {
    // menu togglers
    this._menuTogglers.forEach((el) =>
      el.addEventListener("click", this._handleTogglerClick.bind(this))
    );

    // sub menu buttons
    this._viewActivators.forEach((el) => {
      el.addEventListener("click", (e) =>
        this._handleViewActivatorClick(e, el)
      );
    });

    // back buttons
    this._backBtns.forEach((btnEl) => {
      btnEl.addEventListener("click", this._closeView.bind(this));
    });
  }

  _handleTogglerClick(e) {
    const { toggleActiveClass } = this._classes;
    if (this._isOpen) {
      this._closeAllViews();

      if (toggleActiveClass) {
        e.target.classList.remove(toggleActiveClass);
      }
      return this._close();
    }
    if (toggleActiveClass) {
      e.target.classList.add(toggleActiveClass);
    }
    this._open();
  }

  _handleOutsideClick(e) {
    if (!e.target.closest(this._menuSelector)) {
      this._close();
    }
  }

  _handleEscDown(e) {
    if (e.key === "Escape") {
      this._close();
    }
  }

  _open() {
    this._viewStack.push(this._mainView);
    this._menuEl.classList.add(this._classes.openMenuClass);
    this._menuEl.setAttribute("aria-hidden", "false");
    this._isOpen = true;
    // listen to outside click
    document.addEventListener("mousedown", this._handleOutsideClick);
    // listen for escape button
    document.addEventListener("keydown", this._handleEscDown);
    // disable scroll
    this._disableScroll();
  }

  _close() {
    this._menuEl.classList.remove(this._classes.openMenuClass);
    this._menuEl.setAttribute("aria-hidden", "true");
    this._isOpen = false;
    // stop listening to outside click
    document.removeEventListener("mousedown", this._handleOutsideClick);
    this._enableScroll();
  }

  _enableScroll() {
    window.onscroll = null;
    document.querySelector("body").classList.remove("no-scroll");
  }

  _disableScroll() {
    window.onscroll = () => {
      window.scroll(0, 0);
    };
    document.querySelector("body").classList.add("no-scroll");
  }

  _handleViewActivatorClick(e, el) {
    const targetViewEl = this._menuEl.querySelector(`#${el.dataset.menuId}`);
    if (!targetViewEl) {
      return console.log(
        `Unable to find view with ID "${e.target.dataset.menuId}"`
      );
    }

    this._openView(targetViewEl);
  }

  _openView(viewEl) {
    viewEl.isCustom = viewEl.classList.contains(this._classes.customViewClass);
    const view = this._viewStack.push(viewEl);

    // find back button
    // viewEl.backBtn = viewEl.querySelector(".js-mms-back-button");

    // const parentTitle = view.prev ? view.prev.dataset.parentTitle : null;

    // if (view.prev) this._showBackBtn(parentTitle);

    if (viewEl.isCustom) {
      this._hideFooter();
    } else {
      this._showFooter();
    }

    viewEl.classList.add(this._classes.openViewClass);
  }

  _hideFooter() {
    this._footer.classList.add(this._classes.hideFooterClass);
  }

  _showFooter() {
    this._footer.classList.remove(this._classes.hideFooterClass);
  }

  // _showBackBtn(text) {
  //   this._backBtn.classList.add(this._classes.showBackBtnClass);
  //   this._setbackBtnText(text);
  // }

  _setbackBtnText(text) {
    this._backText.textContent = text || "Main Menu";
  }

  // _hideBackBtn(text) {
  //   this._backBtn.classList.remove(this._classes.showBackBtnClass);
  //   this._setbackBtnText(text);
  // }

  _closeAllViews() {
    // close all views
    while (!this._viewStack.isEmpty()) {
      this._viewStack.pop().classList.remove(this._classes.openViewClass);
    }
    // this._hideBackBtn();
  }

  _closeView() {
    const view = this._viewStack.pop();

    // if (!view.prev.prev) {
    //   this._hideBackBtn();
    // } else {
    //   this._showBackBtn(view.prev.prev.dataset.parentTitle);
    // }

    if (!view.prev.isCustom) this._showFooter();

    view.classList.remove(this._classes.openViewClass);
  }
}

export default (...args) => new MobileMenu(...args);
